<div>
    <div class="content">
        <list-view #listeFacturesTolerances [liste]="toleranceListView" *ngIf="toleranceListView"></list-view>
    </div>
</div>
